import { FormikProps } from "formik";
import { useContext } from "react";
import { PersonNewsletterAndDisclosureSettings } from "../../../../generated/data-contracts";
import {
  AvisDescriptiveText,
  AvisHorizontalChoice,
  AvisSection,
} from "../../../shared/components/form";
import { AvisContext } from "../../../shared/context/AvisContext";

interface IAuthorNotificationsProps {
  bag: FormikProps<PersonNewsletterAndDisclosureSettings>;
  isReadOnly: boolean;
}

export function AuthorNotifications(
  props: Readonly<IAuthorNotificationsProps>,
) {
  const { bag, isReadOnly } = props;
  const { res } = useContext(AvisContext);

  return (
    <AvisSection
      title={res("authors_ContactInfoPage_NotificationsTitle")}
      classNameIn="contact-information-section"
    >
      <AvisDescriptiveText textKey="portal_RH_ContactInfo_1" />
      <AvisHorizontalChoice
        bag={bag}
        bagFieldIn="newsletterForAuthors"
        rowTitle=""
        rowValueLabelYes={res("authors_ContactInfoPage_Notifications_LabelYes")}
        rowValueLabelNo={res("authors_ContactInfoPage_Notifications_LabelNo")}
        isReadOnly={isReadOnly}
      />
    </AvisSection>
  );
}
